module.exports = __webpack_public_path__ + "img/poster.8e51974a.jpg";